
const PermissionFailed = () => {
    return (
        <div>
            <h2 className="error">You do not have permission to view this page!</h2>
        </div>
    )
}

export default PermissionFailed;